import React, { useContext } from 'react';
import { QuestionContext } from './context';

const letters = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
}

function Option({index, text}) {
  const [pickOption] = useContext(QuestionContext);

  const handleOptionClick = index => {
    pickOption(index);
  }

  return (
    <li key={index} onClick={() => handleOptionClick(index)} className='group text-indigo-500 flex items-center space-x-4 w-full ring-2 ring-indigo-400 rounded-lg px-4 py-2 cursor-pointer hover:bg-amber-500 hover:ring-amber-500'>
      <h3 className='group-hover:text-white select-none font-medium text-lg'>{letters[index]}</h3>
      <p className='group-hover:text-white select-none font-medium'>{text}</p>
    </li>
  );
}

export default Option;